import * as types from "./mutation-type";

export default {
    [types.SET_QUIZ](state, payload) {
        state.quiz = payload;
    }
};
